import * as types from "./mutation-types";
import axios from "axios";

export const actions = {
    getBranchen({commit}) {
        commit([types.UPDATE_ERROR_BRANCHEN], false);
        commit(types.UPDATE_LOADING_BRANCHEN, true);

        axios.get(`/api/branches`)
            .then(response => {
                if (response.data.ok) {
                    commit(types.UPDATE_BRANCHEN, response.data.branchen);
                } else {
                    commit([types.UPDATE_ERROR_BRANCHEN], response.data.error);
                }
            })
            .finally(() => commit(types.UPDATE_LOADING_BRANCHEN, false));
    },
}